var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$i18n.locale === "pe"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_cl.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "br"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_br.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    ["cl"].includes(_vm.$i18n.locale)
      ? _c("div", { attrs: { id: "portfolios-container" } }, [
          _c(
            "div",
            {
              staticClass: "card-item mt-6",
              attrs: { id: "portfolios-content" },
            },
            [_c("operation-list", { attrs: { id: "operation-list" } })],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }